import React from 'react';
import { getLocalizedText } from '@vp-dst/localization-util';

import Dropdown from 'components/vistaprintUILibrary/Dropdown';

class ProductSelector extends React.Component {
    constructor(props) {
        super(props);

        this.selectedProductOnChange = this.selectedProductOnChange.bind(this);
    }

    selectedProductOnChange(event) {
        const selectElement = event.target;
        const optionElement = selectElement[selectElement.selectedIndex];

        this.props.selectedProductOnChange({
            name: optionElement.dataset.name,
            pfid: optionElement.value,
            priceHTML: optionElement.dataset.priceHtml,
            priceMultiplier: parseInt(optionElement.dataset.priceMultiplier, 10),
            productGroup: optionElement.dataset.productGroup
        });
    }

    render() {
        const {
            productGroups,
            preSelectedProduct, // the product that was passed to the brief - this option may not be in the product list, so we must add it
            selectedProduct,
            error,
            disabled,
        } = this.props;

        return (
            <div style={{marginBottom: "16px"}}>
                <Dropdown
                    value={selectedProduct ? selectedProduct.pfid : undefined}
                    onChange={this.selectedProductOnChange}
                    disabled={disabled}
                    errorMessage={error ? '' : null} // pass an empty string as the error message so that the dropdown is highlighted, but there's no text
                >
                    {preSelectedProduct &&
                        <option
                            value={preSelectedProduct.pfid}
                            data-name={preSelectedProduct.name}
                            data-price-multiplier={preSelectedProduct.priceMultiplier}
                            data-price-html={preSelectedProduct.priceHTML}
                            data-product-group={preSelectedProduct.productGroup || ""}
                        >
                            {preSelectedProduct.name}
                        </option>
                    }
                    {!preSelectedProduct &&
                        <option value={null} defaultValue>{getLocalizedText('select-a-product')}</option>
                    }
                    {productGroups.map((productGroup) => {
                        return (
                            <optgroup key={`product-opt-group-${productGroup.name.split(' ').join('')}`} label={productGroup.name}>
                                {productGroup.products.map((product) => {
                                    return (
                                        <option
                                            // use product name for key because pfid's are not unique even inside of a single product group
                                            key={`product-option-${productGroup.name.split(' ').join('')}-${product.name.split(' ').join('')}`}
                                            value={product.pfid}
                                            data-name={product.name}
                                            data-price-multiplier={product.priceMultiplier}
                                            data-price-html={product.priceHTML}
                                            data-product-group={product.productGroup}
                                        >
                                            {product.name}
                                        </option>
                                    );
                                })}
                            </optgroup>
                        );
                    })
                }
                </Dropdown>
            </div>
        );
    }
}

export default ProductSelector;


// WEBPACK FOOTER //
// ./src/components/ProductSelector.js